//we have these in controllers/controllers/scroll-animation/constants.ts
//we need to keep them in sync
//until we have proper method to share keyframes between frontend and controllers
export const ANIMATION_KEYFRAMES_CSS = `
@keyframes b4-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes b4-slideUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-slideDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-slideLeft {
  from { opacity: 0; transform: translateX(40px); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-slideRight {
  from { opacity: 0; transform: translateX(-40px); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-zoomIn {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-zoomOut {
  from { opacity: 0; transform: scale(1.15); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-flipUp {
  from { opacity: 0; transform: perspective(600px) rotateX(15deg) translateY(20px); }
  to { opacity: 1; transform: none; }
}

@keyframes b4-bounceIn {
  0% { opacity: 0; transform: translateY(40px); }
  60% { opacity: 1; transform: translateY(-8px); }
  80% { transform: translateY(4px); }
  100% { opacity: 1; transform: none; }
}

@keyframes b4-blurIn {
  from { opacity: 0; filter: blur(12px); }
  to { opacity: 1; filter: none; }
}

@keyframes b4-revealLeft {
  from { clip-path: inset(0 100% 0 0); opacity: 0; }
  to { clip-path: inset(0 0 0 0); opacity: 1; }
}

@keyframes b4-revealRight {
  from { clip-path: inset(0 0 0 100%); opacity: 0; }
  to { clip-path: inset(0 0 0 0); opacity: 1; }
}

@keyframes b4-revealUp {
  from { clip-path: inset(100% 0 0 0); opacity: 0; }
  to { clip-path: inset(0 0 0 0); opacity: 1; }
}

@keyframes b4-revealDown {
  from { clip-path: inset(0 0 100% 0); opacity: 0; }
  to { clip-path: inset(0 0 0 0); opacity: 1; }
}

@keyframes b4-kenBurns {
  0% { transform: scale(1) translate(0, 0); }
  50% { transform: scale(var(--b4-kb-scale, 1.1)) translate(var(--b4-kb-tx, -1%), var(--b4-kb-ty, -1%)); }
  100% { transform: scale(1) translate(0, 0); }
}
@keyframes b4-slowZoom {
  0% { transform: scale(1); }
  50% { transform: scale(var(--b4-sz-scale, 1.08)); }
  100% { transform: scale(1); }
}
@keyframes b4-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: var(--b4-pulse-opacity, 0.85); }
}
`;
